module.exports = __webpack_public_path__ + "static/5-f5f1a0a6217cbb67e62def911f899950.jpg";